import React from 'react';
import MessageBox from '../../../components/MessageBox';

const AdminCustomButton = ({ saveMethod, saveText, className, type, loading, id }) => {
    return (
        <button
            id={id || "adminButton"}
            type={type ? type : "button"}
            disabled={loading}
            onClick={saveMethod}
            className={`${className ? className : "button-bg-color"} theme-button-text-color admin-button-text rounded-3 py-2 px-3`.trim()}
        >
            {loading ? <div className='custom-loading mx-auto'></div> : <MessageBox text={saveText} />}
        </button>
    );
};

export default AdminCustomButton;
